<script>
	export default {
		name: 'StyleExecuter',
		methods: {
			getStylesVal(key, theme) {
				const self_ = this;

				const styles_ = self_.getLocalStorage('styles')

				let theme_ = null
				if(self_.isFalse(theme)) { theme_ = self_.getAppState('theme') }
				else { theme_ = theme }

				const mobileScreen_ = self_.getAppState('isMobileScreen')

				if(self_.isFalse(styles_) || self_.isFalse(key)) { return null }
				else {
					if(self_.isFalse(styles_[key])) { return key }

					if(self_.isFalse(styles_[key][theme_]) && self_.isFalse(styles_[key].default)) { 
						// { key: { mobile: val, web: val } }
						if(self_.isResponsive(styles_[key])) { 
							if(mobileScreen_) {
								return styles_[key].mobile
							} else { return styles_[key].web }
						// { key: val }
						} else { 
							return styles_[key].default
						}
					} else if(styles_[key][theme_]) {
						// { key: { theme: { mobile: val, web: val } } }
						if(self_.isResponsive(styles_[key][theme_])) {
							if(mobileScreen_) {
								return styles_[key][theme_].mobile
							} else { return styles_[key][theme_].web }
						// { key: { theme: val } }
						} else {
							return styles_[key][theme_]
						}
					} else { 
						// { key: { default: {mobile: val, web: val } } }
						if(self_.isResponsive(styles_[key].default)) { 
							if(mobileScreen_) {
								return styles_[key].default.mobile
							} else { return styles_[key].default.web }
						// { key: { default: val } }
						} else { 
							return styles_[key].default
						}
					}
				}
			}
		}
	}
</script>